import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SettingsService } from 'app/settings/settings.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoanTransactionsService {

  constructor(private http: HttpClient,  private settingsService: SettingsService,) { }


  getLoanActionTemplate<LoanRepaymentTemplate>(loanId: string): Observable<any> {
    const httpParams = new HttpParams().set('command', "repayment");
    return this.http.get<LoanRepaymentTemplate>(`/loans/${loanId}/transactions/template`, { params: httpParams });
  }

  submitLoanActionButton(loanId: string, data: any, command: any) {
    const httpParams = new HttpParams().set('command', command);
    return this.http.post(`/loans/${loanId}/transactions`, data, {params: httpParams});
  }

  // Foreclosure for today
  getLoanForeclosureActionTemplate<LoanForeclosureTemplate>(loanId: string): Observable<any> {
    const httpParams = new HttpParams().set('command', "foreclosure");
    return this.http.get<LoanForeclosureTemplate>(`/loans/${loanId}/transactions/template`, { params: httpParams });
  }  
  
  // Foreclosure for a given date
  getLoanForeclosureForDateActionTemplate<LoanForeclosureTemplate>(loanId: string, transactionDate: string): Observable<any> {
    const httpParams = new HttpParams()
                          .set('command', "foreclosure")
                          .set('dateFormat', "MM/dd/yyyy")
                          .set('locale', "en")
                          .set('transactionDate', transactionDate)
                          ;
    return this.http.get<LoanForeclosureTemplate>(`/loans/${loanId}/transactions/template`, { params: httpParams });
  }    

  getLoanRejectCheckTemplate<LoanCheckReversalTemplate>(loanId: string): Observable<any> {
    return this.http.get<LoanCheckReversalTemplate>(`/checks/${loanId}`, {});
  }

  submitLoanRejectCheckT(loanId: string, checkId: string, data: any) {
    const httpParams = new HttpParams().set('command', "rejectCheck");
    return this.http.post(`/loans/${loanId}/checks/${checkId}`, data, {params: httpParams});
  }


    // Foreclosure for a given date
  getForeClosureQuotation(loanId: string, transactionDate: string): Observable<any> {
    let httpParams = new HttpParams()
                          .set('dateFormat', this.settingsService.dateFormat)
                          .set('locale', this.settingsService.language.code)
                          .set('transactionDate', transactionDate);     

    return this.http.get<any>(`/loans/${loanId}/transactions/quote/foreclosure`, { params: httpParams });
  }   

  getPrintableForeClosureQuotation(loanId: string, transactionDate: string,outputFormat: string): Observable<any> {
    let httpParams = new HttpParams()
                          .set('dateFormat', this.settingsService.dateFormat)
                          .set('locale', this.settingsService.language.code)
                          .set('transactionDate', transactionDate)
                          .set('outputFormat', outputFormat);

    let options = { params: httpParams, responseType: "blob" as "json" };
                         

    return this.http.get<any>(`/loans/${loanId}/transactions/quote/foreclosure`,options);
  } 

  responseType: "blob"

}
